import { Component } from '@angular/core';
import { BannerAppComponent } from "../../banner-app/banner-app.component";
import { FooterAppComponent } from "../../footer-app/footer-app.component";
import { NgOptimizedImage } from '@angular/common';

@Component({
    selector: 'app-conexion-interrumpida',
    standalone: false,
    templateUrl: './conexion-interrumpida.component.html',
    styleUrl: './conexion-interrumpida.component.scss',
})
export class ConexionInterrumpidaComponent {

}
